<div class="opportunity-dialog d-flex flex-column h-100">
    <!-- BANNER -->
    <div class="card border-0 mb-5">
        <div class="card-header banner rounded rounded-bottom-0 rounded-top-0 align-content-center">
            <div class="row">
                <div class="col-12">
                    <div class="fs-1 fw-bolder lh-sm">{{ _userData.firstName }} ,</div>
                    <div class="fs-2 lh-sm">{{ 'LETS_CREATE_EQUIPMENT_GROUP' | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- STEPPER -->
    <div class="client-portal-stepper position-sticky top-0 z-10 pb-10 bg-white"
        [class.shadow-bottom]="showStepperShadow">
        <div class="client-portal-stepper-track">
            <div class="client-portal-stepper-progress" [style.width.%]="progressWidth">
            </div>
        </div>
        <div class="client-portal-stepper-items">
            <div class="client-portal-stepper-item" *ngFor="let step of steps; let i = index"
                [class.active]="i === currentFormStep">
                <span class="circle">
                    <i class="far" [class]="'fa-' + step.icon"></i>
                </span>
                <span class="label ms-3 fs-6 fw-bold">{{ step.label }}</span>
            </div>
        </div>
    </div>

    <!-- STEPS CONTENT -->
    <div class="opportunity-content flex-grow-1 overflow-auto px-15 py-4" (scroll)="onScroll()" #scrollableContent>
        <!-- 1 STEP: INVOICE UPLOAD-->
        <ng-container *ngIf="currentFormStep == 0" [formGroup]="newOpportunityForm">
            <div class="card shadow-sm bg-light border border-1 border-gray" *ngIf="!invoiceFetchStatus.fetched">
                <div class="confirmation-header">
                    <h2 class="confirmation-title">
                        <i class="fa fa-upload"></i> {{'UPLOAD_INVOICE' | translate }}
                    </h2>
                    <p class="confirmation-subtitle">
                        <span class="fw-semibold">{{ 'START_QUICKLY' | translate }}</span> 
                        {{ 'UPLOAD_INVOICE_DESCRIPTION' | translate }}
                    </p>
                </div>
                
                <div class="confirmation-sections py-5">
                    <ng-container *ngIf="!invoiceFetchStatus.fetched || (invoiceFetchStatus.fetched && !invoiceFetchStatus.successful)">
                        <div class="upload-area" 
                            [ngClass]="{'dragging': isDragging}" 
                            (dragenter)="onDragEnter($event)"
                            (dragleave)="onDragLeave($event)" 
                            (dragover)="onDragOver($event)" 
                            (drop)="onDrop($event)" 
                            (click)="openFileExplorer()">

                            <div class="upload-icon" [ngClass]="{'dragging': isDragging}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                            </div>

                            <h3 class="upload-title">
                                {{ isDragging ? ('DROP_TO_UPLOAD' | translate) : ('DRAG_INVOICE_HERE' | translate) }}
                            </h3>

                            <p class="upload-description">
                                {{ 'SUPPORTED_FILES_INFO' | translate }}
                            </p>

                            <div class="upload-divider">
                                <span>{{ 'OR' | translate }}</span>
                            </div>

                            <label for="file-upload" class="upload-button" (click)="$event.stopPropagation()">
                                {{ 'SELECT_FILE' | translate }}
                                <input id="file-upload" type="file" accept=".pdf" (change)="onFileSelected($event)" hidden>
                            </label>
                        </div>

                        <div class="upload-note mt-4">
                            <p>
                                <i class="fas fa-info-circle text-primary me-2"></i>
                                <strong>{{ 'NOTE' | translate }}:</strong> {{ 'INVOICE_UPLOAD_OPTIONAL' | translate }}
                            </p>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- Invoice Data-->
            <ng-container *ngIf="invoiceFetchStatus.fetched && invoiceFetchStatus.successful && primaryInvoiceForm?.controls?.supplierName">
                <!-- INFO -->
                <div class="card border border-1 shadow-xs rounded border-gray bg-light">
                    <div class="card-body">
                        <!-- Cabeçalho com fornecedor e ícones -->
                        <div class="d-flex flex-wrap align-items-center gap-4">
                            <!-- Logo -->
                            <ng-container *ngIf="primaryInvoiceForm?.controls?.supplierBrandLogo?.value; else defaultLogo">
                                <img class="supplier-logo me-5" [src]="'data:image/jpeg;base64,' + primaryInvoiceForm?.controls?.supplierBrandLogo?.value">
                            </ng-container>
                            <ng-template #defaultLogo>
                            <span class="supplier-logo me-5">
                                <i class="fas fa-building fs-3hx text-darker-primary"></i>
                            </span>
                            </ng-template>
                    
                            <!-- Fornecedor -->
                            <div class="d-flex flex-column flex-grow-1">
                                <div class="d-flex flex-wrap align-items-center mb-4">
                                    <h1 class="supplier-title me-3 mb-0">
                                    {{ primaryInvoiceForm?.controls?.supplierName?.value || 'Fornecedor Desconhecido' }}
                                    </h1>
                                    <div class="invoice-badge py-1 px-2 fs-8">
                                    <i class="fas fa-bolt text-darker-primary me-2" *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value"></i>
                                    <i class="fas fa-fire-flame-curved text-darker-primary me-2" *ngIf="primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"></i>
                                    <span class="text-dark" *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value">{{ 'ELECTRICITY' | translate }}</span>
                                    <span class="text-dark" *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value">+</span>
                                    <span class="text-dark" *ngIf="primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value">{{ 'NATURAL_GAS' | translate }}</span>
                                    </div>
                                </div>
                        
                                <!-- Datas Fatura-->
                                <div class="d-flex flex-row align-items-center text-gray-700">
                                    <i class="fas fa-calendar-days me-2 text-darker-primary"></i>
                                    <span>{{ primaryInvoiceForm?.controls?.invoiceServiceStartDate?.value | date:'dd-MM-yyyy' }}</span>
                                    <i class="fas fa-arrow-right mx-2 text-darker-primary"></i>
                                    <i class="fas fa-calendar-days me-2 text-darker-primary"></i>
                                    <span>{{ primaryInvoiceForm?.controls?.invoiceServiceEndDate?.value | date:'dd-MM-yyyy' }}</span>
                                </div>
                            </div>
                            
                            <!-- Potencia Contratada / Count Type / Gás Tier -->
                            <div class="d-flex flex-row align-items-center energy-info-container gap-4">
                                <ng-container *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value">
                                        <!--Electricity Count Type-->
                                    <div class="energy-info-item">
                                        <div class="energy-icon-wrapper" matTooltip="{{ 'COUNT_TYPE' | translate }}" matTooltipPosition="above"><i class="far fa-sun-bright"></i></div>
                                        <span class="energy-label text-gray-700">{{ primaryInvoiceForm?.controls?.electricityCountType?.value || ( 'NOT_AVAILABLE' | translate ) }}</span>
                                    </div>
                                    <!--Electricity Contracted Power-->
                                    <div class="energy-info-item">
                                        <div class="energy-icon-wrapper" matTooltip="{{ 'CONTRACTED_POWER' | translate }}" matTooltipPosition="above"><i class="far fa-plug"></i></div>
                                        <span class="energy-label text-gray-700">
                                            {{ primaryInvoiceForm?.controls?.electricityContractedPower?.value ? 
                                                (primaryInvoiceForm?.controls?.electricityContractedPower?.value + ' kVA') : ( 'NOT_AVAILABLE' | translate ) 
                                            }}
                                        </span>
                                    </div>
                                </ng-container>
                                
                                <!-- Gas Tier -->
                                <div class="energy-info-item ms-5" *ngIf="primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value">
                                    <div class="energy-icon-wrapper"><i class="fa fa-battery-half"></i></div>
                                    <span class="energy-label text-gray-700">{{ primaryInvoiceForm?.controls?.naturalGasRating?.value || ( 'NOT_AVAILABLE' | translate ) }}</span>
                                </div>
                            </div>
                            
                            <!-- Vertical divider -->
                            <div class="energy-divider mx-4 border-start"></div>
                            
                            <!-- Total Fatura -->
                            <div class="d-flex flex-column align-items-center text-end">
                            <h1 class="text-darker-primary fs-2 fw-bold">{{ primaryInvoiceForm?.controls?.invoiceTotal?.value ?? '-' }} €</h1>
                            <span class="text-gray-700">{{ 'INVOICE_VALUE' | translate}}</span>
                            </div>
                        </div>
                        
                        <!-- Separador-->
                        <div class="darker-separator text-gray-700 my-10 w-100"></div>

                        <!-- Descrepancia NIF -->
                        <div class="d-flex flex-column rounded bg-light" *ngIf="(invoiceFetchStatus.fetched && invoiceFetchStatus.successful) && (ownEntity.permissions?.tin != otherEntity.permissions?.tin)">            
                            <div class="d-flex flex-row mb-5">
                                <div class="d-flex h-70px w-70px flex-shrink-0 flex-center position-relative me-6 pb-7">
                                    <i class="fas fa-octagon-exclamation text-darker-primary fs-3x position-absolute"></i>
                                </div>
                                <div class="text-gray-700 lh-lg w-100">
                                    <div class="d-flex flex-column mb-5">
                                        <span class="fw-bold fs-5 text-gray-700">{{ 'ATTENTION_DISCREPANCY' | translate }}</span>
                                        <span class="fs-6">{{ 'TIN_DISCREPANCY_MESSAGE' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row g-10 text-gray-700 lh-lg w-100 px-15">
                                <div class="col-6">
                                    <div class="card card-dashed h-xl-100 flex-row flex-stack flex-wrap px-6 tin-card-selection"
                                        (click)="_newFormControls.isOwnTin.setValue(true)">
                                        <!--begin::Info-->
                                        <div class="d-flex flex-column py-2">
                                            <!--begin::Owner-->
                                            <div class="d-flex align-items-center fs-5 fw-bold mb-3 text-gray-700">
                                                <div class="form-check form-check-sm mb-0">
                                                    <input type="radio" class="form-check-input" id="other"
                                                        [value]="true" formControlName="isOwnTin" data-color="darker-primary">
                                                </div>
                                                <span>{{ 'USE_MY_TIN' | translate }}</span>
                                            </div>
                                            <!--end::Owner-->

                                            <!--begin::Wrapper-->
                                            <div class="d-flex align-items-center ms-10 text-gray-500">
                                                <!--begin::Icon-->
                                                <i class="fas fa-id-card fs-3x me-3"
                                                    [class.text-darker-primary]="_newFormControls.isOwnTin.value == true"></i>
                                                <div>
                                                    <div class="fs-6 fw-bold text-dark">{{ ownEntity.permissions?.tin }}</div>
                                                    <div class="fs-7 fw-semibold text-gray-500">{{ ownEntity.permissions?.name }}</div>
                                                </div>
                                                <!--end::Details-->
                                            </div>
                                            <!--end::Wrapper-->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="card card-dashed h-xl-100 flex-row flex-stack flex-wrap px-6 tin-card-selection"
                                        (click)="_newFormControls.isOwnTin.setValue(false)">
                                        <!--begin::Info-->
                                        <div class="d-flex flex-column py-2">
                                            <!--begin::Owner-->
                                            <div class="d-flex align-items-center fs-5 fw-bold mb-3 text-gray-700">
                                                <div class="form-check form-check-sm mb-0">
                                                    <input type="radio" class="form-check-input" id="other"
                                                        [value]="false" formControlName="isOwnTin" data-color="darker-primary">
                                                </div>
                                                {{ 'USE_INVOICE_TIN' | translate}}
                                            </div>
                                            <!--end::Owner-->

                                            <!--begin::Wrapper-->
                                            <div class="d-flex align-items-center ms-10 text-gray-500">
                                                <!--begin::Icon-->
                                                <i class="fas fa-id-card fs-3x me-3"
                                                    [class.text-text-darker-primary]="_newFormControls.isOwnTin.value == false"></i>
                                                <div>
                                                    <div class="fs-6 fw-bold text-dark">
                                                        {{ otherEntity.permissions?.tin }}
                                                    </div>
                                                    <div class="fs-7 fw-semibold text-gray-500">
                                                        {{ otherEntity.permissions?.name }}
                                                    </div>
                                                </div>
                                                <!--end::Details-->
                                            </div>
                                            <!--end::Wrapper-->
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <!-- Separador-->
                        <div class="darker-separator text-gray-700 my-10 w-100" *ngIf="(invoiceFetchStatus.fetched && invoiceFetchStatus.successful) && (ownEntity.permissions?.tin != otherEntity.permissions?.tin)"></div>

                        <!-- Grid com dados da entidade e equipamentos -->
                        <div class="row px-5 g-4">
                            <!-- Entidade -->
                            <div [class.col-4]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                            [class.col-5]="(primaryInvoiceForm?.controls?.isElectricityInvoice?.value && !primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value) 
                                || (!primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value)">
                                <h4 class="section-title mb-4 fw-bold text-gray-700 fs-5">
                                    <i class="fas fa-user me-2"></i> {{ 'ENTITY_DATA' | translate }}
                                </h4>
                               <div class="row g-3 bg-white border border-gray rounded border-dashed px-4 py-2"
                                [class.row-cols-1]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                                [class.row-cols-2]="(primaryInvoiceForm?.controls?.isElectricityInvoice?.value && !primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value)
                                                    || (!primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value)">
                                
                                <!-- TIN -->
                                <div class="col text-overflow">
                                    <div class="text-sm text-gray-500">
                                    <i class="fas fa-id-card text-muted me-1"></i> {{ 'TIN' | translate }}
                                    </div>
                                    <div class="font-medium text-overflow"
                                    [ngClass]="{ 'text-danger': !_newFormControls.entity.controls.tin.value, 'text-darker-primary': _newFormControls.entity.controls.tin.value }"
                                    [matTooltip]="_newFormControls.entity.controls.tin.value || ('NOT_AVAILABLE' | translate)">
                                    {{ _newFormControls.entity.controls.tin.value || ('-' | translate) }}
                                    </div>
                                </div>

                                <!-- NAME -->
                                <div class="col text-overflow">
                                    <div class="text-sm text-gray-500">
                                    <i class="fas fa-user text-muted me-1"></i> {{ 'NAME' | translate }}
                                    </div>
                                    <div class="font-medium text-overflow"
                                    [ngClass]="{ 'text-danger': !_newFormControls.entity.controls.name.value, 'text-darker-primary': _newFormControls.entity.controls.name.value }"
                                    [matTooltip]="_newFormControls.entity.controls.name.value || ('NOT_AVAILABLE' | translate)">
                                    {{ _newFormControls.entity.controls.name.value || ('-' | translate) }}
                                    </div>
                                </div>

                                <!-- ADDRESS -->
                                <div class="col text-overflow">
                                    <div class="text-sm text-gray-500">
                                    <i class="fas fa-map-marker-alt text-muted me-1"></i> {{ 'ADDRESS' | translate }}
                                    </div>
                                    <div class="font-medium text-overflow"
                                    [ngClass]="{ 'text-danger': !_newFormControls.entity.controls.address.value, 'text-darker-primary': _newFormControls.entity.controls.address.value }"
                                    [matTooltip]="((_newFormControls.entity.controls.address.controls.finalValue.value ?? '') | translate)">
                                    {{ _newFormControls.entity.controls.address.value || ('-' | translate) }}
                                    </div>
                                </div>

                                <!-- ZIP CODE -->
                                <div class="col text-overflow">
                                    <div class="text-sm text-gray-500">
                                    <i class="fas fa-envelope text-muted me-1"></i> {{ 'ZIP_CODE' | translate }}
                                    </div>
                                    <div class="font-medium text-overflow"
                                    [ngClass]="{ 'text-danger': !_newFormControls.entity.controls.postalCode.value, 'text-darker-primary': _newFormControls.entity.controls.postalCode.value }"
                                    [matTooltip]="(_newFormControls.entity.controls.postalCode.controls.finalValue.value) || ('NOT_AVAILABLE' | translate)">
                                    {{ _newFormControls.entity.controls.postalCode.value || ('-' | translate) }}
                                    </div>
                                </div>

                                <!-- PARISH -->
                                <div class="col text-overflow">
                                    <div class="text-sm text-gray-500">
                                    <i class="fas fa-buildings text-muted me-1"></i> {{ 'PARISH' | translate }}
                                    </div>
                                    <div class="font-medium text-overflow"
                                    [ngClass]="{ 'text-danger': !_newFormControls.entity.controls.parish.value, 'text-darker-primary': _newFormControls.entity.controls.parish.value }"
                                    [matTooltip]="((_newFormControls.entity.controls.parish.controls.finalValue.value?.toString() ?? '') | translate)">
                                    {{ _newFormControls.entity.controls.parish.value || ('-' | translate) }}
                                    </div>
                                </div>
                                </div>

                            </div>
                    
                            <!-- Equipamento de Eletricidade -->
                            <div class="px-10" *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value"
                                [class.col-4]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                                [class.col-7]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && !primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value">
                                <h4 class="section-title mb-5 text-gray-700 fs-5">
                                    <i class="fas fa-plug me-2"></i> {{ 'EQUIPMENT_DATA' | translate }}
                                </h4>
                                <div class="row row-cols-1 row-cols-md-2 g-4 bg-white border border-gray rounded border-dashed px-4 py-2">
                                    <!-- Reusable field block -->
                                    <ng-template #comparisonTemplate let-field="field" let-label="label" let-icon="icon">
                                    <div class="text-sm text-gray-500">
                                        <i class="fas {{ icon }} me-1 text-muted"></i>
                                        {{ label | translate }}
                                    </div>
                                    <ng-container [ngSwitch]="field.comparisonResult.value">
                                        <span *ngSwitchCase="'match'" class="font-medium text-darker-primary text-truncate d-block"
                                            [matTooltip]="field.finalValue.value ?? ''">
                                        {{ field.finalValue.value }}
                                        </span>
                                        <span *ngSwitchCase="'notFound'" class="font-medium text-danger text-truncate d-block"
                                            [matTooltip]="field.invoiceValue.value ?? ''">
                                        {{ field.invoiceValue.value ?? ('NOT_AVAILABLE' | translate) }}
                                        </span>
                                        <ng-container *ngSwitchCase="'mismatch'">
                                        <span class="text-darker-primary">
                                            {{ field.serverValue.value }}
                                            <i class="fas fa-exclamation-circle text-warning ms-1" 
                                                matTooltip="Valor diferente da fatura: {{ field.invoiceValue.value }}"></i>
                                            </span>
                                        </ng-container>
                                        <span *ngSwitchDefault class="font-medium text-danger">{{ 'NOT_AVAILABLE' | translate }}</span>
                                    </ng-container>
                                    </ng-template>

                                    <!-- Código do Equipamento -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.equipmentCode?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'EQUIPMENT_CODE', icon: 'fa-barcode' }"></ng-container>
                                    </div>

                                    <!-- Nível de Tensão -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.tensionLevel?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'TENSION_LEVEL', icon: 'fa-bolt' }"></ng-container>
                                    </div>

                                    <!-- Ciclo Horário -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.timeCycle?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'TIME_CYCLE', icon: 'fa-clock' }"></ng-container>
                                    </div>

                                    <!-- Morada de Fornecimento -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.street?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'SUPPLY_ADDRESS', icon: 'fa-map-marker-alt' }"></ng-container>
                                    </div>

                                    <!-- Freguesia -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.parish?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'SUPPLY_PARISH', icon: 'fa-buildings' }"></ng-container>
                                    </div>

                                    <!-- Código Postal -->
                                    <div class="col text-overflow" *ngIf="_primaryInvoiceElectricityEquipmentData?.controls?.postalCode?.controls as field">
                                        <ng-container *ngTemplateOutlet="comparisonTemplate; context: { field: field, label: 'SUPPLY_ZIP_CODE', icon: 'fa-envelope' }"></ng-container>
                                    </div>

                                </div>
                            </div>

                            <!-- Equipamento de Gás --> 
                             
                            <ng-template #comparisonRenderer let-field>
                            <ng-container *ngIf="field?.comparisonResult?.value as comparison">
                                <ng-container [ngSwitch]="comparison">
                                <span *ngSwitchCase="'match'" class="font-medium text-persian-green text-overflow" [matTooltip]="field.finalValue.value ?? ''">
                                    {{ field.finalValue.value }}
                                </span>
                                <span *ngSwitchCase="'notFound'" class="font-medium text-danger text-overflow" [matTooltip]="field.invoiceValue.value ?? ''">
                                    {{ field.invoiceValue.value }}
                                </span>
                                <ng-container *ngSwitchCase="'mismatch'">
                                    <div class="d-flex flex-column align-items-center">
                                    <span class="font-medium text-danger me-1" [matTooltip]="'Fatura'">
                                        {{ field.invoiceValue.value }}
                                    </span>
                                    <i class="fas fa-arrow-down text-muted small my-1"></i>
                                    <span class="font-medium text-success" [matTooltip]="'Base de dados'">
                                        {{ field.serverValue.value }}
                                    </span>
                                    </div>
                                </ng-container>
                                <span *ngSwitchDefault class="font-medium text-danger">
                                    {{ 'NOT_AVAILABLE' | translate }}
                                </span>
                                </ng-container>
                            </ng-container>
                            </ng-template>

                            <!-- Equipamento de Gás -->
                            <div class="px-10" *ngIf="primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                            [class.col-4]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                            [class.col-7]="(!primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value)">
                            <h4 class="section-title mb-5 text-gray-700 fs-5">
                                <i class="fas fa-fire-flame-curved text-danger me-2"></i> Equipamento de Gás
                            </h4>

                            <div class="row gap-3 bg-white border border-gray rounded border-dashed px-4 py-2"
                                [class.row-cols-1]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                                [class.row-cols-2]="(!primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value)">

                                <!-- EQUIPMENT CODE -->
                                <div class="col">
                                <div class="text-sm text-gray-500"><i class="fas fa-barcode me-1"></i> {{ 'EQUIPMENT_CODE' | translate }}</div>
                                <ng-container *ngIf="_primaryInvoiceNaturalGasEquipmentData?.controls?.equipmentCode?.controls as field">
                                    <ng-container *ngTemplateOutlet="comparisonRenderer; context: { $implicit: field }"></ng-container>
                                </ng-container>
                                </div>

                                <!-- PRESSURE LEVEL -->
                                <div class="col">
                                <div class="text-sm text-gray-500"><i class="fas fa-gauge-high me-1"></i> {{ 'PRESSURE_LEVEL' | translate }}</div>
                                <ng-container *ngIf="_primaryInvoiceNaturalGasEquipmentData?.controls?.pressureLevel?.controls as field">
                                    <ng-container *ngTemplateOutlet="comparisonRenderer; context: { $implicit: field }"></ng-container>
                                </ng-container>
                                </div>

                                <!-- SUPPLY ADDRESS -->
                                <div class="col">
                                <div class="text-sm text-gray-500"><i class="fas fa-location-dot me-1"></i> {{ 'SUPPLY_ADDRESS' | translate }}</div>
                                <ng-container *ngIf="_primaryInvoiceNaturalGasEquipmentData?.controls?.street?.controls as field">
                                    <ng-container *ngTemplateOutlet="comparisonRenderer; context: { $implicit: field }"></ng-container>
                                </ng-container>
                                </div>

                                <!-- SUPPLY PARISH -->
                                <div class="col">
                                <div class="text-sm text-gray-500"><i class="fas fa-map-location-dot me-1"></i> {{ 'SUPPLY_PARISH' | translate }}</div>
                                <ng-container *ngIf="_primaryInvoiceNaturalGasEquipmentData?.controls?.parish?.controls as field">
                                    <ng-container *ngTemplateOutlet="comparisonRenderer; context: { $implicit: field }"></ng-container>
                                </ng-container>
                                </div>

                                <!-- SUPPLY ZIP CODE -->
                                <div class="col">
                                <div class="text-sm text-gray-500"><i class="fas fa-envelope me-1"></i> {{ 'SUPPLY_ZIP_CODE' | translate }}</div>
                                <ng-container *ngIf="_primaryInvoiceNaturalGasEquipmentData?.controls?.postalCode?.controls as field">
                                    <ng-container *ngTemplateOutlet="comparisonRenderer; context: { $implicit: field }"></ng-container>
                                </ng-container>
                                </div>

                            </div>
                            </div>

                        </div>
                    
                        <!-- Separador-->
                        <div class="darker-separator text-gray-700 my-10 w-100"></div>

                        <!-- Tabela Consumos -->
                        <div class="row px-5">
                            <ng-container *ngIf="primaryInvoiceForm?.controls?.isElectricityInvoice?.value">
                                    <div class="col-6">
                                        <div class="consumption-section">
                                            <h4 class="section-title mb-4 text-gray-700 fs-5">{{ 'ENERGY_VARIABLE_TERM' | translate }}</h4>
                                            <div class="table-responsive">
                                            <table class="table table-sm table-bordered consumption-table">
                                                <thead class="table-light">
                                                <tr>
                                                    <th>{{ 'CONSUMPTION' | translate }}</th>
                                                    <th>{{ 'UNIT_PRICE' | translate }} (€/kWh)</th>
                                                    <th>{{ 'CONSUMPTION' | translate }} ({{ 'consumption' | energyUnit }})</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>P1</td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityPriceP1?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityPriceP1?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityConsumptionP1?.value" >
                                                            {{ (primaryInvoiceForm?.controls?.electricityConsumptionP1?.value | kwhEnergy) || '-' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P2</td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityPriceP2?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityPriceP2?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityConsumptionP2?.value" >
                                                            {{ (primaryInvoiceForm?.controls?.electricityConsumptionP2?.value | kwhEnergy) || '-' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P3</td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityPriceP3?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityPriceP3?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityConsumptionP3?.value" >
                                                            {{ (primaryInvoiceForm?.controls?.electricityConsumptionP3?.value | kwhEnergy) || '-' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P4</td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityPriceP4?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityPriceP4?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityConsumptionP4?.value" >
                                                            {{ (primaryInvoiceForm?.controls?.electricityConsumptionP4?.value | kwhEnergy) || '-' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr class="table-total">
                                                        <td class="text-end fw-bold" colspan="2">{{ 'TOTAL_CONSUMPTION' | translate }}</td>
                                                        <td class="fw-bold">
                                                            <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityTotalConsumption?.value" >
                                                                {{ (primaryInvoiceForm?.controls?.electricityTotalConsumption?.value | kwhEnergy) || '-' }}
                                                            </span>
                                                            ({{ 'consumption' | energyUnit }})
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="consumption-section">
                                            <h4 class="section-title mb-4 text-gray-700 fs-5">{{ 'ENERGY_FIXED_TERM' | translate }}</h4>
                                            <div class="table-responsive">
                                            <table class="table table-sm table-bordered consumption-table">
                                                <thead class="table-light">
                                                <tr>
                                                    <th>{{ 'CONTRACTED_POWER' | translate }} (kVA)</th>
                                                    <th>{{ 'CONTRACTED_POWER_PRICE' | translate }} (€/kWh)</th>
                                                    <th>{{ 'CONTRACTED_POWER_PRICE_PHP' | translate }} (€/kWh)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td [class.text-danger]="!primaryInvoiceForm?.controls?.electricityContractedPower?.value">
                                                        {{primaryInvoiceForm?.controls?.electricityContractedPower?.value ?? '-'}}
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityContractedPowerPrice?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityContractedPowerPrice?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class.text-danger]="!primaryInvoiceForm?.controls?.electricityContractedPowerPHPPrice?.value" >
                                                            {{primaryInvoiceForm?.controls?.electricityContractedPowerPHPPrice?.value ?? '-'}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            <div *ngIf="primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                            [class.col-12]="!primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value"
                            [class.col-6]="primaryInvoiceForm?.controls?.isElectricityInvoice?.value && primaryInvoiceForm?.controls?.isNaturalGasInvoice?.value">
                                <div class="consumption-section">
                                    <h4 class="section-title mb-4 text-gray-700 fs-5">{{ 'NATURAL_GAS_CONSUMPTIONS' | translate }}</h4>
                                    <div class="table-responsive">
                                    <table class="table table-sm table-bordered consumption-table">
                                        <thead class="table-light">
                                        <tr>
                                            <th>{{ 'TIER' | translate}}</th>
                                            <th>{{'PRICE' | translate}} (€)</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>{{primaryInvoiceForm?.controls?.naturalGasRating?.value}}</td>
                                            <td>{{primaryInvoiceForm?.controls?.naturalGasPrice?.value}}</td>
                                        </tr>
                                        
                                        </tbody>
                                        <tfoot>
                                        <tr class="table-total">
                                            <td colspan="1" class="text-end fw-bold">{{ 'TOTAL_CONSUMPTION' | translate }}</td>
                                            <td class="fw-bold">{{ primaryInvoiceForm?.controls?.naturalGasTotalConsumption?.value | kwhEnergy }} ({{ 'consumption' | energyUnit }})</td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- 2 STEP: GENERAL DATA TAB-->
        <ng-container *ngIf="currentFormStep == 1">
            <div class="card shadow-sm bg-light border border-1 border-gray">
                <div class="confirmation-header">
                    <h2 class="confirmation-title">
                        <i class="fa fa-pen-circle"></i> {{ 'FILL_DATA' | translate}}
                    </h2>
                    <p class="confirmation-subtitle">{{ 'FILL_DATA_DESCRIPTION' | translate }}</p>
                </div>
                <div class="confirmation-sections py-5">
                    <!-- ENTITY DATA -->
                    <div class="confirmation-section">
                        <div class="section-header">
                            <i class="fas fa-user section-icon"></i>
                            <h3 class="section-title">{{ 'ENTITY_DATA'| translate }}</h3>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="newOpportunityForm">
                                <!-- ENTITY SELECTION -->
                                <div class="form-row" *ngIf="!invoiceFile && (!invoiceFetchStatus.fetched && !invoiceFetchStatus.successful)">
                                    <div class="form-group">
                                        <label class="form-label" for="entity">
                                            {{ 'ENTITY' | translate }}
                                        </label>
                                        <div class="radio-options">
                                            <div class="form-check">
                                                <input #meInput type="radio" class="form-check-input" id="me" [value]="true"
                                                    formControlName="isOwnTin" data-color="blue">
                                                <label for="me" class="form-check-label">{{ 'SELF' | translate }}</label>
                                            </div>
                                            <div class="form-check">
                                                <input type="radio" class="form-check-input" id="other" [value]="false"
                                                    formControlName="isOwnTin" data-color="blue">
                                                <label for="other" class="form-check-label">{{ 'OTHER' | translate }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-divider" *ngIf="!invoiceFile && (!invoiceFetchStatus.fetched && !invoiceFetchStatus.successful)"></div>

                                <!-- TIN & NAME & CONTRACT TYPE-->
                                <div class="data-grid" [formGroup]="newOpportunityForm.controls.entity">

                                    <!-- TIN -->
                                    <div class=" position-relative">
                                        <label class="form-label" for="tin">{{ 'TIN' | translate }}</label>
                                        <div class="position-relative">
                                            <input class="form-control form-control-sm pe-5" id="tin" formControlName="tin" type="number" 
                                            placeholder="{{'TIN' | translate}}">
                                            <!-- [absolutePositioning]="false" -->
                                            <mat-progress-spinner
                                            *ngIf="isFetchingEntity"
                                            mode="indeterminate"
                                            diameter="18"
                                            strokeWidth="3"
                                            class="position-absolute top-50 end-0 translate-middle-y me-2 text-darker-primary">>
                                            </mat-progress-spinner>
                                        </div>
                                    </div>

                                    <!-- NAME -->
                                    <div class=" position-relative">
                                        <label class="form-label" for="entityName">{{ 'NAME' | translate }}</label>
                                        <div class="position-relative">
                                            <input class="form-control form-control-sm pe-5" id="entityName" formControlName="name" type="text" placeholder="{{'NAME' | translate}}">
                                            <!-- [absolutePositioning]="false" -->
                                            <div class="uploader-status">
                                                <mat-progress-spinner
                                                *ngIf="isFetchingEntity"
                                                mode="indeterminate"
                                                diameter="18"
                                                strokeWidth="3"
                                                class="position-absolute top-50 end-0 translate-middle-y me-2">
                                                </mat-progress-spinner>
                                            </div>
                                        </div>
                                    </div>
 
                                    <!-- MOBILE_PHONE -->
                                    <div class="" [formGroup]="newOpportunityForm.controls.entity.controls.phoneNumber">
                                        <label class="form-label">
                                            {{ 'MOBILE_PHONE' | translate }}
                                        </label>
                                        <input class="form-control form-control-sm" formControlName="finalValue" type="text" placeholder="{{'MOBILE_PHONE' | translate}}">
                                    </div>

                                    <!-- EMAIL -->
                                    <div class="" [formGroup]="newOpportunityForm.controls.entity.controls.email">
                                        <label class="form-label">
                                            {{ 'EMAIL' | translate }}
                                        </label>
                                        <input class="form-control form-control-sm" formControlName="finalValue" type="text" placeholder="{{'EMAIL' | translate}}">
                                    </div>

                                    <!-- ADDRESS -->
                                    <div class="" [formGroup]="newOpportunityForm.controls.entity.controls.address">
                                        <label class="form-label">
                                            {{ 'ADDRESS' | translate }}
                                        </label>
                                        <input class="form-control form-control-sm" formControlName="finalValue" type="text" placeholder="{{'NAME' | translate}}">
                                    </div>

                                    <!-- ZIP CODE -->
                                     <div class="" [formGroup]="newOpportunityForm.controls.entity.controls.postalCode">
                                         <label class="form-label">
                                             {{ 'ZIP_CODE' | translate }}
                                         </label>
                                         <input class="form-control form-control-sm" formControlName="finalValue" type="text" placeholder="{{'ZIP_CODE' | translate}}">
                                     </div>

                                    <!-- PARISH -->
                                    <div class="" [formGroup]="newOpportunityForm.controls.entity.controls.parish">
                                        <label class="form-label">
                                            {{ 'PARISH' | translate }}
                                        </label>
                                        <input class="form-control form-control-sm" formControlName="finalValue" type="text" formControlName="finalValue" placeholder="{{'PARISH' | translate}}">
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <!-- GROUP DATA -->
                    <div class="confirmation-section">
                        <div class="section-header">
                            <i class="fas fa-file-lines section-icon"></i>
                            <h3 class="section-title">{{ 'EQUIPMENT_GROUP_DATA'| translate }}</h3>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="newOpportunityForm">
                                <div class="data-grid">
                                    <!-- GROUP NAME -->
                                    <div class="form-group">
                                        <label class="form-label">
                                            {{ 'NAME' | translate }}
                                        </label>
                                        <input class="form-control form-control-sm" type="text" formControlName="name" 
                                        placeholder="{{'INSERT_GROUP_NAME' | translate}}">
                                    </div>

                                    <!-- GROUPING NAME -->
                                    <div class="form-group">
                                        <label class="form-label">
                                            {{ 'MARKET' | translate }}
                                            <div class="required-mark">*</div>
                                        </label>
                                        <input class="form-control form-control-sm" 
                                        formControlName="groupingName">
                                        <!-- [absolutePositioning]="false" -->
                                    </div>

                                    <!-- CONTRACT TYPE -->
                                    <div class="form-group" [formGroup]="newOpportunityForm">
                                        <label class="form-label" for="contractType">
                                            {{ 'CONTRACT_TYPE' | translate }}
                                        </label>
                                        <is-select [Options]="contractTypes" formControlName="contractType" [smallInput]="true"
                                            [solid]="false" [menuFitInput]="true">
                                        </is-select>
                                    </div>

                                    <!-- LOYALTY PERIOD -->
                                    <div class="form-group">
                                        <label class="form-label" for="loyaltyPeriod">
                                            {{ 'CONTRACT_DURATION' | translate }}
                                        </label>
                                        <is-select placeholder="{{'LOYALTY_PERIOD' | translate}}" [solid]="false" [smallInput]="true" 
                                            [Options]="loyaltyPeriodOptions" formControlName="loyaltyPeriod"></is-select> 
                                    </div>

                                    <!-- EXPECTED START DATE-->
                                    <div class="form-group">
                                        <label class="form-label" for="expectedStartDate">
                                            {{ 'EXPECTED_START_DATE' | translate }}
                                            <i class="far fa-circle-exclamation tooltip-icon me-1"
                                                matTooltip="{{ 'EXPECTED_START_DATE_TOOLTIP' | translate }}"
                                                matTooltipClass="custom-tooltip-width"></i>
                                        </label>
                                        <is-date-time-picker [solid]="false" [smallInput]="true" [Type]="dateType" formControlName="expectedStartDate"></is-date-time-picker>
                                        <!-- [absolutePositioning]="false" -->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- 3 STEP: EQUIPMENTS-->
        <ng-container *ngIf="currentFormStep == 2">
            <div class="card shadow-sm bg-light border border-1 border-gray">
                <div class="confirmation-header">
                    <div class="d-flex flex-row">
                        <div class="d-flex flex-column me-auto">
                            <h2 class="confirmation-title">
                                <i class="fa fa-plug"></i> {{ 'EQUIPMENTS' | translate }}
                            </h2>
                            <p class="confirmation-subtitle">
                                {{ 'EQUIPMENT_DESCRIPTION' | translate}}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="card-body bg-white bottom-radius p-0">
                    <!-- Equipment Management Interface -->
                    <div class="equipment-management-container d-flex" style="height: 500px;">
                        <!-- Sidebar -->
                        <div class="equipment-sidebar border-end bg-light d-flex flex-column" style="width: 320px;" *ngIf="_equipmentFormArrayControls.length > 0 || showingAddInterface">
                            <!-- Sidebar Header -->
                            <div class="sidebar-header px-3 py-4 border-bottom bg-white" *ngIf="!showingAddInterface">
                                <!--<div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0 fw-semibold">{{ 'EQUIPMENT_LIST' | translate }}</h6>
                                    <span class="badge bg-secondary text-xs" *ngIf="_equipmentFormArrayControls.length > 0">
                                        {{getValidEquipmentCount()}}/{{_equipmentFormArrayControls.length}}
                                    </span>
                                </div>
                                <div class="text-xs text-danger d-flex align-items-center gap-1" *ngIf="getEquipmentsWithErrors() > 0">
                                    <i class="fas fa-exclamation-circle"></i>
                                    {{getEquipmentsWithErrors()}} {{ 'EQUIPMENT_WITH_ERRORS' | translate }}
                                </div>-->
                                
                                <!-- Add Equipment Button -->
                                <div class="">
                                    <div class="dropdown" *ngIf="selectedGroupingForElectricity && selectedGroupingForNaturalGas; else singleTypeButton">
                                        <button class="btn btn-sm btn-primary w-100 d-flex justify-content-center text-center" (click)="showAddEquipmentInterface()">
                                            <i class="fa-solid fa-plus me-1 fa-fw fa-fh"></i>
                                            {{ 'ADD_EQUIPMENT' | translate }}
                                        </button>
                                    </div>
                                    
                                    <ng-template #singleTypeButton>
                                        <!--<button *ngIf="selectedGroupingForElectricity" class="btn-electricity w-100 d-flex justify-content-center text-center"
                                            (click)="showAddEquipmentInterface('electricity')">
                                            <i class="fa-solid fa-bolt me-1 fa-fw fa-fh"></i>
                                            {{ 'ELECTRICITY' | translate}}
                                            <i class="fa-solid fa-plus fa-fw fa-fh"></i>
                                        </button>
                                         <button class="btn-gas w-100 d-flex justify-content-center text-center"
                                            *ngIf="selectedGroupingForNaturalGas"
                                            (click)="showAddEquipmentInterface('gas')">
                                            <i class="fa-solid fa-fire-flame-curved me-1 fa-fw fa-fh"></i>
                                            {{ 'GAS' | translate}}
                                            <i class="fa-solid fa-plus fa-fw fa-fh"></i>
                                        </button>-->
                                    </ng-template>
                                </div>
                            </div>

                            <!-- Equipment List -->
                            <div class="sidebar-content flex-fill overflow-auto p-2">
                                <div class="equipment-list" *ngIf="_equipmentFormArrayControls.length > 0; else emptyListTemplate">
                                    <ng-container *ngFor="let equipmentFormGroup of _equipmentFormArrayControls; let i = index">
                                        <div class="equipment-list-item mb-2" 
                                            [class.selected]="selectedEquipmentIndex === i"
                                            [class.electricity-item]="formGroupIsElectricity(equipmentFormGroup.controls)"
                                            [class.gas-item]="!formGroupIsElectricity(equipmentFormGroup.controls)"
                                            (click)="selectEquipment(i)">
                                            
                                            <div class="equipment-item-content p-3">
                                                <div class="d-flex justify-content-between align-items-start">
                                                    <div class="flex-fill min-width-0">
                                                        <!-- Equipment Header -->
                                                        <div class="d-flex align-items-center gap-2 mb-1">
                                                            <i class="fas text-xs" 
                                                            [ngClass]="formGroupIsElectricity(equipmentFormGroup.controls) ? 'fa-bolt text-warning' : 'fa-fire text-danger'">
                                                            </i>
                                                            <span class="equipment-code text-xs fw-medium text-truncate">
                                                                {{ equipmentFormGroup.controls.equipmentCode.controls.finalValue.value || ('NEW_EQUIPMENT' | translate) }}
                                                            </span>
                                                        </div>

                                                        <!-- Equipment Summary -->
                                                        <div class="equipment-summary-compact d-flex align-items-center gap-2 text-xs text-muted mb-2">
                                                            <ng-container *ngIf="formGroupIsElectricity(equipmentFormGroup.controls)">
                                                                <span *ngIf="equipmentFormGroup.controls.contractedPower.controls.finalValue.value">
                                                                    {{ equipmentFormGroup.controls.contractedPower.controls.finalValue.value }} kVA
                                                                </span>
                                                                <span *ngIf="equipmentFormGroup.controls.countType.controls.finalValue.value">
                                                                    • {{ getCountTypeLabelKey(equipmentFormGroup.controls.countType.controls.finalValue.value) | translate }}
                                                                </span>
                                                            </ng-container>
                                                        </div>

                                                        <!-- Status Badges -->
                                                        <div class="d-flex align-items-center gap-1">
                                                            <span class="badge badge-sm text-xs" 
                                                                [ngClass]="isEquipmentValid(equipmentFormGroup) ? 'bg-light-success text-sucess' : 'bg-light-warning text-warning'">
                                                                <i class="fas me-1" [ngClass]="isEquipmentValid(equipmentFormGroup) ? 'fa-check' : 'fa-clock'"></i>
                                                                {{ isEquipmentValid(equipmentFormGroup) ? ('VALID' | translate) : ('INCOMPLETE' | translate) }}
                                                            </span>
                                                            
                                                            <span class="badge badge-sm bg-light-danger text-danger text-xs" *ngIf="hasEquipmentErrors(equipmentFormGroup)">
                                                                <i class="fas fa-exclamation-circle me-1"></i>
                                                                {{ 'ERRORS' | translate }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <!-- Actions -->
                                                    <div class="d-flex align-items-center gap-1 ms-2">
                                                        <button type="button" 
                                                                class="btn-remove"
                                                                (click)="removeEquipment(i); $event.stopPropagation()">
                                                            <i class="fa fa-times text-xs"></i>
                                                        </button>
                                                        <i class="fas fa-chevron-right text-xs text-primary btn-toggle" *ngIf="selectedEquipmentIndex === i"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                
                                <ng-template #emptyListTemplate>
                                    <div class="text-center py-4 h-100 d-flex flex-column align-items-center justify-content-center">
                                        <div class="d-flex flex-column text-center">
                                            <i class="fas fa-plug text-muted fa-2x mb-2"></i>
                                            <p class="text-muted text-sm mb-0">{{ 'NO_EQUIPMENT_YET' | translate }}</p>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>

                            <!-- Sidebar Footer -->
                            <div class="sidebar-footer p-3 border-top bg-white">
                                <div class="equipments-summary-compact">
                                    <div class="d-flex justify-content-between text-sm mb-1">
                                        <span class="text-muted">{{'TOTAL_EQUIPMENT' | translate}}:</span>
                                        <span class="fw-medium">{{_equipmentFormArrayControls.length}}</span>
                                    </div>
                                    <div class="d-flex justify-content-between text-sm">
                                        <span class="text-muted">{{'CONTRACT_DURATION' | translate}}:</span>
                                        <span class="fw-medium">{{ _newFormControls.loyaltyPeriod.value ? (_newFormControls.loyaltyPeriod.value + ' ') : '-' }} {{ 'MONTHS' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Main Content Area -->
                        <div class="equipment-main-content flex-fill d-flex flex-column">
                            <!-- Add Equipment Interface -->
                            <ng-container *ngIf="showingAddInterface; else equipmentFormTemplate">
                                <div class="equipment-main-header px-3 py-4 border-bottom bg-white">
                                    <div class="d-flex align-items-center gap-3">
                                        <div class="equipment-icon rounded-3 d-flex align-items-center justify-content-center"
                                            [ngClass]="addEquipmentType === 'electricity' ? 'bg-warning bg-opacity-10' : 'bg-danger bg-opacity-10'"
                                            style="width: 35px; height: 35px;">
                                            <i class="fa" [ngClass]="addEquipmentType === 'electricity' ? 'fa-bolt text-warning' : 'fa-fire-flame-curved text-danger'"></i>
                                        </div>
                                        <div>
                                            <h4 class="mt-2 fw-semibold">
                                                <span class="ms-2">
                                                    {{ 'ADD_EQUIPMENT' | translate }}
                                                    <ng-container *ngIf="addEquipmentType">
                                                        {{ (addEquipmentType === 'electricity' ? 'ELECTRICITY' : 'GAS') | translate }}
                                                    </ng-container>
                                                </span>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="equipment-main-form flex-fill overflow-auto p-5">
                                    <!-- Equipment Code Input-->
                                    <div class="" *ngIf="!addEquipmentInvoiceFile">
                                        <form [formGroup]="addEquipmentGroup">
                                            <label class="form-label fw-bold">
                                                {{ 'EQUIPMENT_CODE' | translate }}
                                            </label>
                                            <input type="text" class="form-control" [formControlName]="'equipmentCode'" 
                                                [placeholder]="'INSERT_CODE_MANUALLY' | translate" [errorMessage]="addEquipmentErrorCodes" />
                                        </form>
                                        
                                        <!-- <span class="fs-8 ms-2 text-danger" *ngIf="addEquipmentCode.invalid && addEquipmentCode.dirty">
                                            {{ 'INVALID_EQUIPMENT_CODE' | translate}}
                                        </span> -->
                                    </div>
                                    
                                    <!-- Or -->
                                    <div class="text-center my-3 text-muted" *ngIf="!addEquipmentInvoiceFile && !addEquipmentGroup.controls.equipmentCode.value">{{ 'OR' | translate}}</div>
                                    
                                    <!-- Upload Invoice Area-->
                                    <ng-container *ngIf="!addEquipmentGroup.controls.equipmentCode.value">
                                        <p class="form-label fw-bold">
                                            {{ 'UPLOAD_INVOICE_INFO' | translate }}
                                        </p>
                                        <div class="bg-light p-4 rounded border border-dashed" *ngIf="!addEquipmentInvoiceFile">
                                            <div class="upload-container px-6">
                                                <div class="upload-area" [ngClass]="{'dragging': isDragging}" 
                                                    (dragenter)="onDragEnter($event)" 
                                                    (dragleave)="onDragLeave($event)" 
                                                    (dragover)="onDragOver($event)" 
                                                    (drop)="onDrop($event)">
                                                    <div class="upload-icon" style="width: 40px; height: 40px" [ngClass]="{'dragging': isDragging}">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                            <polyline points="17 8 12 3 7 8"></polyline>
                                                            <line x1="12" y1="3" x2="12" y2="15"></line>
                                                        </svg>
                                                    </div>

                                                    <h3 class="upload-title">
                                                        {{ isDragging ? ('DROP_TO_UPLOAD' | translate) : ('DRAG_INVOICE_HERE' | translate) }}
                                                    </h3>

                                                    <p class="upload-description">
                                                        {{ 'SUPPORTED_FILES_INFO' | translate }}
                                                    </p>

                                                    <div class="upload-divider">
                                                        <span>{{ 'OR' | translate }}</span>
                                                    </div>

                                                    <label for="file-upload" class="upload-button">
                                                        {{ 'SELECT_FILE' | translate }}
                                                        <input id="file-upload" type="file" accept=".pdf" (change)="onFileSelected($event)" hidden>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <!-- Equipment Form Template -->
                            <ng-template #equipmentFormTemplate>
                                <ng-container *ngIf="selectedEquipmentIndex !== null && selectedEquipmentFormGroup; else noSelectionTemplate">
                                    <!-- Equipment Header -->
                                    <div class="equipment-main-header px-3 py-4 border-bottom bg-white">
                                        <div class="d-flex align-items-center gap-3">
                                            <div class="equipment-icon rounded-3 d-flex align-items-center justify-content-center"
                                                [ngClass]="formGroupIsElectricity(selectedEquipmentFormGroup.controls) ? 'bg-warning bg-opacity-10' : 'bg-danger bg-opacity-10'"
                                                style="width: 35px; height: 35px;">
                                                <i class="fas" 
                                                [ngClass]="formGroupIsElectricity(selectedEquipmentFormGroup.controls) ? 'fa-bolt text-warning' : 'fa-fire text-danger'">
                                                </i>
                                            </div>
                                            <div>
                                                <h4 class="mt-2 fw-semibold">
                                                    {{ selectedEquipmentFormGroup.controls.equipmentCode.controls.finalValue.value || 'Novo Equipamento' }}
                                                </h4>
                                            </div>
                                        </div>

                                        <!-- Error Alert
                                        <div class="alert alert-danger d-flex align-items-center mt-3" *ngIf="hasEquipmentErrors(selectedEquipmentFormGroup)">
                                            <i class="fas fa-exclamation-circle me-2"></i>
                                            <span>{{ 'EQUIPMENT_HAS_REQUIRED_FIELDS_OR_INVALID_DATA' | translate }}</span>
                                        </div> -->
                                    </div>

                                    <!-- Form Content -->
                                    <div class="equipment-main-form flex-fill overflow-auto px-3" id="equipmentContent">
                                        <form [formGroup]="selectedEquipmentFormGroup">
                                            
                                            <!-- Tab Content (keeping your existing form content) -->
                                            <div class="equipment-tab-content-main px-5">
                                                <!-- General Data -->
                                                <ng-container *ngIf="equipmentSelectedTabs[selectedEquipmentIndex] === 0">
                                                    <!-- Electricity Equipment -->
                                                     <!-- General Data Tab -->
                                                    <div class="equipment-tabs-main mt-2 mb-5">
                                                        <ul class="nav nav-tabs">
                                                            <li class="nav-item">
                                                                <a class="nav-link active"  [attr.data-color]="formGroupIsElectricity(selectedEquipmentFormGroup.controls) ? 'warning' : 'danger'">
                                                                    {{ 'GENERAL_DATA' | translate }}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <ng-container *ngIf="formGroupIsElectricity(selectedEquipmentFormGroup.controls); else naturalGasTemplate">
                                                        <div class="equipment-data-grid my-5 px-5">
                                                            <!-- Equipment Code -->
                                                            <div class="form-group col-span-2">
                                                                <label class="form-label" for="equipmentCode">
                                                                    {{ 'CPE'| translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.equipmentCode">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue"
                                                                        [errorMessage]="{errorMessage: 'INVALID_CPE_CODE', notUnique: 'DUPLICATE_CPE_CODE'}"
                                                                        type="text" [autofocus]="true">
                                                                </div>
                                                            </div>
                                                            <!-- Tension Level -->
                                                            <div class="form-group">
                                                                <label class="form-label" for="tensionLevel">
                                                                    {{ 'TENSION_LEVEL' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.tensionLevel">
                                                                    <is-select [DataSource$]="tensionLevelDatasource$" [solid]="false"
                                                                        [httpMethod]="'GET'" [smallInput]="true"
                                                                        formControlName="finalId"></is-select>
                                                                </div>
                                                            </div>
                                                            <ng-container *ngIf="countryCode == 'PT'; then ElectricityDataPT; else ElectricityDataES"></ng-container>
                                                            <ng-template #ElectricityDataPT>
                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPower">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>
                                                            
                                                                <!-- Count Type -->
                                                                <div class="form-group">
                                                                    <label class="form-label" for="countType">
                                                                        {{ 'COUNT_TYPE' | translate }}
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.countType">
                                                                        <is-select [DataSource$]="countTypesDatasource$" [solid]="false"
                                                                            [translateData]="true" [httpMethod]="'GET'" [smallInput]="true"
                                                                            formControlName="finalId"></is-select>
                                                                    </div>
                                                                </div>
                                                                <!-- Time Cycle -->
                                                                <div class="form-group">
                                                                    <label class="form-label" for="timeCycle">
                                                                        {{ 'TIME_CYCLE' | translate }}
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.timeCycle">
                                                                        <is-select [DataSource$]="timeCyclesDatasource$" [solid]="false"
                                                                            [translateData]="true" [httpMethod]="'GET'" [smallInput]="true"
                                                                            formControlName="finalId"></is-select>
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                            <ng-template #ElectricityDataES>
                                                                <!-- Count Type -->
                                                                <div class="form-group">
                                                                    <label class="form-label" for="countType">
                                                                        {{ 'TARIFF' | translate }}
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.electricityTariff">
                                                                        <is-select [DataSource$]="electricityTariffDatasource$" [solid]="false"
                                                                            [translateData]="true" [httpMethod]="'POST'" [smallInput]="true"
                                                                            formControlName="finalId"></is-select>
                                                                    </div>
                                                                </div>
                                                                <!-- P1 -->
                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P1 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP1">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P2 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP2">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P3 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP3">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P4 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP4">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P5 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP5">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="form-label" for="contractedPower">
                                                                        {{ 'CONTRACTED_POWER' | translate }} P6 (kVA)
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <div [formGroup]="selectedEquipmentFormGroup.controls.contractedPowerP6">
                                                                        <input class="form-control form-control-sm"
                                                                            formControlName="finalValue" type="number">
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                            
                                                        </div>
                                                    </ng-container>

                                                    <!-- Natural Gas Equipment-->
                                                    <ng-template #naturalGasTemplate>
                                                        <div class="equipment-data-grid my-5 px-5" *ngIf="formGroupIsNaturalGas(selectedEquipmentFormGroup.controls)">
                                                            <div class="form-group col-span-2">
                                                                <label class="form-label" for="equipmentCode">
                                                                    {{ 'CUI'| translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.equipmentCode">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue"
                                                                        type="text" [autofocus]="true"
                                                                        [errorMessage]="{pattern: 'INVALID_CUI_CODE', notUnique: 'DUPLICATE_CUI_CODE'}">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group" [formGroup]="selectedEquipmentFormGroup.controls.pressureLevel">
                                                                <label class="form-label" for="pressureLevel">
                                                                    {{ 'PRESSURE_LEVEL' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <is-select [DataSource$]="pressureLevelDatasource$"
                                                                    [httpMethod]="'GET'" [smallInput]="true" [solid]="false"
                                                                    formControlName="finalId"></is-select>
                                                            </div>
                                                            
                                                            <div class="form-group" [formGroup]="selectedEquipmentFormGroup.controls.tariffOption">
                                                                <label class="form-label" for="tariffOption">
                                                                    {{ 'TARIFF' | translate }}
                                                                </label>
                                                                <is-select [DataSource$]="tariffOptionDatasource$"
                                                                    [translateData]="true" [httpMethod]="'GET'"
                                                                    [smallInput]="true" [solid]="false"
                                                                    formControlName="finalId"
                                                                    [disabled]="tier.length > 0"></is-select>
                                                            </div>

                                                            <ng-container *ngIf="pressureLevel == 'BP'">
                                                                <div class="form-group" [formGroup]="selectedEquipmentFormGroup.controls.tier">
                                                                    <label class="form-label" for="tier">
                                                                        {{ 'TIER' | translate }}
                                                                        <span class="required-mark">*</span>
                                                                    </label>
                                                                    <is-select [DataSource$]="tierDatasource$"
                                                                        [translateData]="true"
                                                                        [httpMethod]="'GET'" [smallInput]="true" [solid]="false"
                                                                        formControlName="finalId"
                                                                        [disabled]="tariffOption.length > 0"></is-select>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </ng-template>

                                                    <!-- Address -->
                                                    <div class="equipment-tabs-main">
                                                        <ul class="nav nav-tabs">
                                                            <li class="nav-item">
                                                                <a class="nav-link active"  [attr.data-color]="formGroupIsElectricity(selectedEquipmentFormGroup.controls) ? 'warning' : 'danger'">
                                                                    {{ 'ADDRESS' | translate }}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="equipment-data-grid my-5 px-5">
                                                        <div class="form-group">
                                                            <label class="form-label" for="postalCode">
                                                                {{ 'ZIP_CODE' | translate }}
                                                                <span class="required-mark">*</span>
                                                            </label>
                                                            <div [formGroup]="selectedEquipmentFormGroup.controls.postalCode" (change)="onZipCodeFilled()">
                                                                <input class="form-control form-control-sm" formControlName="finalValue">
                                                            </div>
                                                        </div>
                                                        <!-- this._zipCodeRegexpPattern().test(zipCode) -->
                                                        <!-- <ng-container *ngIf="selectedEquipmentFormGroup?.controls?.postalCode?.value?.finalValue?.length! > 0"> -->
                                                        <ng-container *ngIf="_zipCodeRegexpPattern().test(selectedEquipmentFormGroup.controls.postalCode.controls.finalValue.value!)">
                                                            <div class="form-group">
                                                                <label class="form-label" for="county">
                                                                    {{ 'COUNTY' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.county">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group">
                                                                <label class="form-label" for="district">
                                                                    {{ 'DISTRICT' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.district">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue" type="text">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group">
                                                                <label class="form-label" for="locality">
                                                                    {{ 'LOCALITY' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.locality">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group" *ngIf="selectedEquipmentFormGroup">
                                                                <label class="form-label" for="parish">
                                                                    {{ 'PARISH' | translate }}
                                                                    <span class="required-mark">*</span>
                                                                </label>

                                                                <!-- when there are no options (or control is disabled) fall back to a plain text input -->
                                                                <div *ngIf="!showParishSelect" [formGroup]="selectedEquipmentFormGroup!.controls.parish">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>

                                                                <!-- otherwise show the select component with the list for the currently selected equipment -->
                                                                <div *ngIf="showParishSelect" [formGroup]="selectedEquipmentFormGroup!.controls.parish">
                                                                    <is-select [solid]="false" [smallInput]="true" [Options]="currentParishOptions" formControlName="finalValue"></is-select>
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group">
                                                                <label class="form-label" for="street">
                                                                    {{ 'STREET' | translate }}
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.street">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group">
                                                                <label class="form-label" for="floor">
                                                                    {{ 'FLOOR' | translate }}
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.floor">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="form-group">
                                                                <label class="form-label" for="door">
                                                                    {{ 'DOOR' | translate }}
                                                                </label>
                                                                <div [formGroup]="selectedEquipmentFormGroup.controls.door">
                                                                    <input class="form-control form-control-sm" formControlName="finalValue">
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>

                                                    <!-- Consumptions -->
                                                    <div class="equipment-tabs-main">
                                                        <ul class="nav nav-tabs">
                                                            <li class="nav-item">
                                                                <a class="nav-link active"  [attr.data-color]="formGroupIsElectricity(selectedEquipmentFormGroup.controls) ? 'warning' : 'danger'">
                                                                    {{ 'CONSUMPTIONS' | translate }}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="px-5 my-5">
                                                        <new-app-consumptions [consumptionsFormArray]="selectedEquipmentFormGroup.controls.consumptions"
                                                        [isElectricity]="formGroupIsElectricity(selectedEquipmentFormGroup.controls)"></new-app-consumptions>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </form>
                                    </div>
                                </ng-container>

                                <!-- No Selection Template -->
                                <ng-template #noSelectionTemplate>
                                    <ng-container *ngIf="_equipmentFormArrayControls.length > 0; else noEquipmentTemplate">
                                        <div class="equipment-no-selection d-flex align-items-center justify-content-center flex-fill">
                                            <div class="text-center">
                                                <div class="equipment-icon-large rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3"
                                                    style="width: 80px; height: 80px;">
                                                    <i class="fas fa-plug fa-2x text-muted"></i>
                                                </div>
                                                <h5 class="fw-semibold text-dark mb-2">{{ 'SELECT_EQUIPMENT' | translate }}</h5>
                                                <p class="text-muted">
                                                    {{ 'SELECT_EQUIPMENT_FROM_LIST_TO_EDIT' | translate }}
                                                </p>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-template>

                                <ng-template #noEquipmentTemplate> 
                                    <div class="empty-state d-flex flex-column flex-fill justify-content-center text-center align-items-middle ng-star-inserted h-100 bg-light">
                                        <div class="empty-icon mb-4 d-flex justify-content-center align-items-center">
                                            <div class="h-60px w-60px bg-light shadow-sm d-flex text-center justify-content-center align-items-center rounded-circle">
                                                <i class="fa-solid fa-plug text-muted fs-1"></i>
                                            </div>
                                        </div>
                                        <h5 class="fw-semibold text-muted mb-3">
                                            {{ 'NO_EQUIPMENT_ADDED' | translate}}
                                        </h5>
                                        <p class="text-muted mb-4">
                                            {{ 'ADD_EQUIPMENT_TO_CONTINUE' | translate}}
                                        </p>
                                        <div class="d-flex justify-content-center gap-3 flex-wrap">
                                            <button *ngIf="selectedGroupingForElectricity" class="btn-electricity"
                                                (click)="showAddEquipmentInterface()">
                                                <i class="fa-solid fa-bolt me-1 fa-fw fa-fh"></i>
                                                {{ 'ELECTRICITY' | translate}}
                                                <i class="fa-solid fa-plus fa-fw fa-fh"></i>
                                            </button>
                                            <button *ngIf="selectedGroupingForNaturalGas" class="btn-gas"
                                                (click)="showAddEquipmentInterface()">
                                                <i class="fa-solid fa-fire-flame-curved me-1 fa-fw fa-fh"></i>
                                                {{ 'GAS' | translate}}
                                                <i class="fa-solid fa-plus fa-fw fa-fh"></i>
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- 4 STEP: CONFIRMATION TAB -->
        <ng-container *ngIf="currentFormStep == 3">
            <div class="card shadow-sm bg-light border border-1 border-gray">
                <div class="confirmation-header">
                    <h2 class="confirmation-title">
                        <i class="fa fa-check-circle"></i> {{'REVIEW_AND_SUBMIT' | translate}}
                    </h2>
                    <p class="confirmation-subtitle">{{ 'REVIEW_DESCRIPTION'| translate }}</p>
                </div>

                <div class="confirmation-sections py-5">
                    <div class="row g-3">
                        <div class="col-6">
                             <!-- Seção Dados da Entidade -->
                            <div class="confirmation-section">
                                <div class="section-header">
                                    <i class="fa fa-user section-icon"></i>
                                    <h3 class="section-title">{{ 'ENTITY_DATA' | translate }}</h3>
                                    <button class="edit-button" (click)="goToStep(1)">
                                        <i class="fa fa-pencil"></i> {{ 'EDIT' | translate}}
                                    </button>
                                </div>
                                <div class="section-content">
                                    <div class="equipment-data-grid">
                                        <div class="data-item">
                                            <span class="data-label">{{ 'TIN'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.entity.controls.tin.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'NAME'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.entity.controls.name.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'ADDRESS'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.entity.controls.address.controls.finalValue.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'ZIP_CODE'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.entity.controls.postalCode.controls.finalValue.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'PARISH'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.entity.controls.parish.controls.finalValue.value ?? '-'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <!-- Seção Dados do Grupo -->
                            <div class="confirmation-section">
                                <div class="section-header">
                                    <i class="fa fa-file-lines section-icon"></i>
                                    <h3 class="section-title">{{ 'GROUP_DATA' | translate }}</h3>
                                    <button class="edit-button" (click)="goToStep(1)">
                                        <i class="fa fa-pencil"></i> {{ 'EDIT' | translate}}
                                    </button>
                                </div>
                                <div class="section-content">
                                    <div class="equipment-data-grid">
                                        <div class="data-item">
                                            <span class="data-label">{{ 'NAME'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.name.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'MARKET'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.groupingName.value ?? '-'}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'EXPECTED_START_DATE'| translate }}</span>
                                            <span class="data-value">{{_newFormControls.expectedStartDate.value | date:('dd/MM/yyyy')}}</span>
                                        </div>
                                        <div class="data-item">
                                            <span class="data-label">{{ 'CONTRACT_DURATION'| translate }}</span>
                                            <span class="data-value">{{(_newFormControls.loyaltyPeriod.value ?? '-') + ' '}} {{ 'MONTHS' | translate }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                             <!-- Seção Equipamentos -->
                            <div class="confirmation-section">
                                <div class="section-header">
                                    <i class="fa fa-bolt section-icon"></i>
                                    <h3 class="section-title">{{ 'EQUIPMENTS' | translate }}</h3>
                                    <button class="edit-button" (click)="goToStep(2)">
                                        <i class="fa fa-pencil"></i> {{ 'EDIT' | translate}}
                                    </button>
                                </div>
                                <div class="section-content equipment-scroll-container">
                                    <div *ngFor="let eq of _newElectricityEquipmentFormArrayControls; let i = index" class="equipment-card"
                                    [class.electricity-card]="formGroupIsElectricity(eq.controls)" [class.gas-card]="!formGroupIsElectricity(eq.controls)">
                                        <div class="equipment-header">
                                            <div class="equipment-title">
                                                <i class="fas fa-bolt text-warning"></i>
                                                <span class="equipment-code">{{ eq.controls.equipmentCode.controls.finalValue.value || 'Novo Equipamento' }}</span>
                                            </div>
                                            <span class="equipment-badge electricity">{{ 'ELECTRICITY' | translate }}</span>
                                        </div>
                                        <div class="equipment-details">
                                            <div class="equipment-grid">
                                                <div class="data-item">
                                                    <span class="data-label">{{ 'CONTRACTED_POWER' | translate }}</span>
                                                    <span class="data-value">{{ eq.controls.contractedPower.controls.finalValue.value ?? '-' }} kVA</span>
                                                </div>
                                                <div class="data-item">
                                                    <span class="data-label">{{ 'TIME_CYCLE' | translate }}</span>
                                                    <span class="data-value">{{ (eq.controls.timeCycle.controls.finalValue.value ?? '-') | translate }}</span>
                                                </div>
                                                <div class="data-item">
                                                    <span class="data-label">{{ 'ZIP_CODE' | translate }}</span>
                                                    <span class="data-value">{{ eq.controls.postalCode.controls.finalValue.value ?? '-' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngFor="let eq of _newNaturalGasEquipmentFormArrayControls; let i = index" class="equipment-card">
                                        <div class="equipment-header">
                                            <div class="equipment-title">
                                                <i class="fas fa-fire text-danger"></i>
                                                <span class="equipment-code">{{ eq.controls.equipmentCode.controls.finalValue.value || 'Novo Equipamento' }}</span>
                                            </div>
                                            <span class="equipment-badge gas">{{ 'GAS' | translate }}</span>
                                        </div>
                                        <div class="equipment-details">
                                            <div class="equipment-grid">
                                                <!-- Add gas-specific fields here if needed -->
                                                <div class="data-item">
                                                    <span class="data-label">{{ 'ZIP_CODE' | translate }}</span>
                                                    <span class="data-value">{{ eq.controls.postalCode.controls.finalValue.value ?? '-' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <div class="confirmation-summary my-0">
                                    <div class="summary-item">
                                        <span class="summary-label">{{'TOTAL_EQUIPMENT' | translate}}:</span>
                                        <span class="summary-value">{{_equipmentFormArrayControls.length}}</span>
                                    </div>
                                    <div class="summary-item">
                                        <span class="summary-label">{{'CONTRACT_DURATION' | translate}}:</span>
                                        <span class="summary-value">{{_newFormControls.loyaltyPeriod.value + ' ' }} {{ 'MONTHS' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- NAVIGATION BUTTONS -->
    <div class="opportunity-footer position-sticky bottom-0 z-10  bg-white px-15 py-7"
        [class.shadow-top]="showFooterShadow">
        <div class="d-flex flex-row-reverse">
            <button class="btn btn-sm btn-outline btn-outline-primary" (click)="nextStep()" *ngIf="currentFormStep != 3">
                <span *ngIf="currentFormStep == 0 && !invoiceFetchStatus.fetched">{{ 'CONTINUE_WITHOUT_INVOICE' | translate }}</span>
                <span *ngIf="currentFormStep == 0 && invoiceFetchStatus.fetched">{{ 'CONTINUE' | translate }}</span>
                <span *ngIf="currentFormStep == 1 || currentFormStep == 2">{{ 'CONTINUE' | translate }}</span>
                <i class="fas fa-chevron-right fs-7 ms-2"></i>
            </button>
            <button class="btn btn-sm btn-outline btn-outline-secondary me-2" (click)="resetUpload()" 
                *ngIf="invoiceFetchStatus.fetched && invoiceFetchStatus.successful && currentFormStep == 0">
                <span>{{ 'UPLOAD_ANOTHER_INVOICE' | translate }}</span>
                <i class="fas fa-upload fs-7 ms-2"></i>
            </button>

            <button *ngIf="currentFormStep == 3" class="btn btn-sm btn-outline btn-outline-primary" (click)="submitOpportunity()">
                <span >{{ 'SUBMIT' | translate }}</span>
                <i class="fas fa-floppy-disk fs-7 ms-2"></i>
            </button>

            <button *ngIf="currentFormStep != 0" class="btn btn-sm btn-outline btn-outline-secondary me-2"
                (click)="previousStep()">
                <i class="fas fa-chevron-left fs-7 me-2"></i>
                <span>{{ 'BACK' | translate}}</span>
            </button>
        </div>
    </div>
</div>

<!-- SPINNER -->
<ngx-spinner type="ball-spin-clockwise" name="invoiceSpinner"><span class="text-white">{{ 'ANALYZING_INVOICE' | translate }}</span></ngx-spinner>